import React from 'react';
import DashboardImage1 from "./DashboardImage1.png"
import "./Login.css"
const DeviceDisplay = () => {
  return (
    <div className="device-display">
        <img src={DashboardImage1} className='deviceImages'/>
      {/* <div className="device phone-left">
        <div className="device-frame"></div>
        <div className="device-content" style={{ backgroundImage: "url('/placeholder.svg')" }}></div>
      </div>
      
      <div className="device laptop">
        <div className="device-frame"></div>
        <div className="device-content" style={{ backgroundImage: "url('/placeholder.svg')" }}></div>
      </div>
      
      <div className="device phone-right">
        <div className="device-frame"></div>
        <div className="device-content" style={{ backgroundImage: "url('/placeholder.svg')" }}></div>
      </div> */}
    </div>
  );
};

export default DeviceDisplay;